// PersonnelDeleteConfirmationModal.tsx
import React from 'react';

// Inline styles to ensure proper modal positioning and styling
const modalStyles = {
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1050,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  },
  container: {
    background: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
    maxWidth: '400px',
    width: '100%',
    margin: '0 auto'
  },
  content: {
    padding: '32px',
    textAlign: 'center' as const
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#374151',
    margin: '0 0 16px 0',
    lineHeight: 1.3
  },
  message: {
    fontSize: '16px',
    color: '#6b7280',
    margin: '0 0 32px 0',
    lineHeight: 1.5
  },
  highlight: {
    fontWeight: 600,
    color: '#374151'
  },
  actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center'
  },
  button: {
    padding: '12px 24px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: 'none',
    minWidth: '100px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cancelButton: {
    background: '#ffffff',
    color: '#374151',
    border: '1px solid #d1d5db'
  },
  deleteButton: {
    background: '#dc2626',
    color: '#ffffff',
    border: '1px solid #dc2626'
  }
};

interface PersonnelDeleteConfirmationModalProps {
  isOpen: boolean;
  personnelName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PersonnelDeleteConfirmationModal: React.FC<PersonnelDeleteConfirmationModalProps> = ({
  isOpen,
  personnelName,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.container}>
        <div style={modalStyles.content}>
          <h2 style={modalStyles.title}>Delete Personnel</h2>
          <p style={modalStyles.message}>
            Are you sure you want to delete "<span style={modalStyles.highlight}>{personnelName}</span>"?
          </p>
          <div style={modalStyles.actions}>
            <button
              onClick={onConfirm}
              style={{...modalStyles.button, ...modalStyles.deleteButton}}
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#b91c1c';
                e.currentTarget.style.borderColor = '#b91c1c';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#dc2626';
                e.currentTarget.style.borderColor = '#dc2626';
              }}
            >
              Delete
            </button>
            <button
              onClick={onCancel}
              style={{...modalStyles.button, ...modalStyles.cancelButton}}
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#f9fafb';
                e.currentTarget.style.borderColor = '#9ca3af';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#ffffff';
                e.currentTarget.style.borderColor = '#d1d5db';
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};